import React from "react";
import { useObserver } from "mobx-react-lite";
import { Grid, Typography } from "@material-ui/core";
import { Dialog, Link, Table } from "components";
import { StoreProvider, useStore } from "./Store";
import { FormStoreProvider, useFormStore } from "./FormStore";
import Form from "./Form";

export const Page = () => {
  const store = useStore();
  const formStore = useFormStore();

  React.useEffect(() => {
    store.fetchDevelopers();
  }, [store]);

  const open = React.useCallback(() => formStore.modal(true), [formStore]);
  const close = React.useCallback(() => formStore.modal(false), [formStore]);

  return useObserver(() => (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs="auto">
        <Typography variant="h6" color="textSecondary">
          開発者
        </Typography>
      </Grid>

      <Grid item xs="auto">
        <Dialog
          title="開発者"
          open={formStore.open}
          onOpen={open}
          onClose={close}
        >
          <Form />
        </Dialog>
      </Grid>

      <Grid item xs={12}>
        <Table
          title=""
          isLoading={store.loading}
          options={{
            exportFileName: "開発者",
          }}
          data={store.developers}
          columns={[
            {
              title: "名前",
              field: "name",
              render: (developer) => (
                <Link to={`/developers/${developer.id}/apps`}>
                  {developer.name}
                </Link>
              ),
            },
          ]}
          actions={[
            {
              icon: "edit",
              tooltip: "編集",
              onClick: (_, developer) =>
                !Array.isArray(developer) &&
                formStore.modal(true, {
                  id: developer.id,
                  name: developer.name,
                }),
            },
          ]}
        />
      </Grid>
    </Grid>
  ));
};

export default () => (
  <StoreProvider>
    <FormStoreProvider>
      <Page />
    </FormStoreProvider>
  </StoreProvider>
);
